/* eslint-disable react/no-unescaped-entities */
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
const TermsAndCondition = () => {
  const router = useRouter();
  useEffect(() => {
    // Check if the user is coming from the privacy policy link
    const { fromCheckoutPage, fromImageUpload } = router.query;
    const isFromTermsAndConditionLink = fromCheckoutPage === 'true';
    const isFromImageUploadLink = fromImageUpload === 'true';

    if (isFromTermsAndConditionLink) {
      // Scroll to the privacy policy section
      const TermsAndConditionSection = document.getElementById(
        'phone-number-security'
      );
      if (TermsAndConditionSection) {
        TermsAndConditionSection.scrollIntoView({ behavior: 'smooth' });
      }
    }

    if (isFromImageUploadLink) {
      // Scroll to the image upload section
      const imageUploadSection = document.getElementById(
        'image-upload-section'
      );
      if (imageUploadSection) {
        imageUploadSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [router.query]);
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, minimum-scale = 1.0"
        />
        <meta
          name="og:title"
          content={'Terms and Conditions - See Sight Tours'}
        />
        <meta
          name="og:description"
          content={'The Terms and Conditions Of See Sight Tours '}
        />
        <title>Terms and Conditions - See Sight Tours </title>
        <meta
          name="description"
          content={'The Terms and Conditions Page Of See Sight Tours '}
        />
        <link
          rel="canonical"
          href={'https://www.seesight-tours.com/terms-and-conditions'}
        />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
      </Head>
      <div className="py-8 px-2 w-full">
        <div className="flex justify-center items-center">
          <h2 className="text-lg lg:text-2xl font-bold">
            See Sight Tours Partner Program
          </h2>
        </div>
        <div className="px-6 md:px-10 lg:px-28 flex flex-col justify-start">
          <div className="flex flex-col gap-3  mt-6">
            <h2 className="text-md underline ">General Terms</h2>
            <p className="text-base text-justify">
              Welcome to the See Sight Tours Partner Program, an online portal
              and program offering a suite of optional business services
              (“Services”) including but not limited to the See Sight Tours
              Agent Program and the See Sight Tours Affiliate Program.
            </p>
            <p>
              This Agreement contains the terms and conditions that govern your
              access to and use of the Services through a particular account and
              is an agreement between you or the business you represent (as
              provided in the sign-up process and as set out in the Account
              Information section of the See Sight Tours Partner Program
              platform) and See Sight Tours, Inc. (the “Agreement”). By
              registering for or using the Services, you (on behalf of yourself
              or the business you represent) agree to be bound by the terms of
              this Agreement, including the Service terms and applicable
              policies for each Service you register for or use (each, a set of
              “Service Terms”).
            </p>
            <p>
              If you are collaborating with See Sight Tours pursuant to a
              commercial arrangement not described in Sections A or B of this
              Agreement, the contractual terms that relate to such arrangement
              will be separately agreed between you and See Sight Tours, and
              those separately-agreed contractual terms will prevail over any
              conflicting terms in this Agreement.
            </p>
            <p>
              As used in this Agreement, “we”, “us” and “See Sight Tours” means
              See Sight Tours,, and “you” means the person (if registering for
              or using a Service as an individual), or the business the person
              is employed by or represents (if registering for or using a
              Service on behalf of a business).
            </p>
            <p>
              Capitalized terms have the meanings listed in the Definitions
              section below. If there is any conflict between these General
              Terms and the applicable Service Terms, the Service Terms will
              govern.
            </p>

            <p>
              The version of this Agreement in English is the definitive legal
              version. Any translated versions are available for ease of
              reference only.
            </p>
          </div>
          <div className="flex flex-col gap-3 mt-3">
            <h2 className="text-md  underline ">1. Registration</h2>
            <p className="text-base text-justify">
              To start using a Service, you must complete the registration
              process for one or more of the Services by providing all of the
              required information within the Account Information section of the
              See Sight Tours Partner Program platform. Use of the Services is
              limited to parties that can lawfully enter into and form contracts
              under applicable law. Before you can begin to access or use any of
              the Services, you must provide us with certain mandatory pieces of
              information, including but not limited to your legal name (and/or
              that of your business), address, telephone number, website address
              (if applicable) and e-mail address. We may at any time cease
              providing any or all of the Services at our sole discretion and
              without notice.
            </p>
          </div>
          <div className="flex flex-col gap-3 mt-3">
            <h2 className="text-md  underline ">2. Term/termination</h2>
            <p className="text-base text-justify">
              The term of this Agreement will start on the date of your
              completed registration of a See Sight Tours Partner Program
              account (“See Sight Tours Partner Program Account”) and shall
              continue until terminated by us or you as provided below (the
              “Term”). We may terminate or suspend this Agreement or any Service
              immediately by notice to you for any reason at any time. You may
              terminate this Agreement or any Service for any reason at any time
              by the means then specified by us. Termination or suspension of a
              Service will not terminate or suspend any other Service unless
              explicitly stated. Upon termination, all rights and obligations of
              the parties under this Agreement will terminate, except that
              Sections 2, 4 - 9, and 15 - 19 will survive termination. Any terms
              that expressly survive according to the applicable Service Terms
              will also survive termination.
            </p>
          </div>
          <div className="flex flex-col gap-3 mt-3">
            <h2 className="text-md  underline ">
              3. Intellectual Property; Content
            </h2>
            <p className="text-base text-justify">
              <strong>3.1</strong> You agree and acknowledge that the Customer
              Information, the See Sight Tours Marketplace, the Travel Product
              Information, the Travel Product Links, the See Sight Tours APIs,
              and all information, technology and materials related thereto, and
              intellectual property rights therein and thereto, are the sole
              property of See Sight Tours or its licensors, and you may not
              display, use or reproduce such materials, technology and
              information for any purpose, other than as expressly set forth in
              this Agreement.
            </p>
            <p className="text-base text-justify">
              <strong>3.2</strong> If a license is granted to you under a set of
              Service Terms, you may offer and make available for purchase all
              or some of the Travel Products, but must display all Travel
              Product Information provided by See Sight Tours with respect to
              any Travel Product displayed or otherwise promoted by you. You may
              not add to, enhance, supplement, alter, modify or amend the Travel
              Product Information in whole or in part without See Sight Tours's
              prior consent. You will promptly correct any errors or
              inaccuracies of which See Sight Tours notifies you. You may not
              systematically analyze or extract information (including guest
              reviews) from the See Sight Tours Marketplace or Agent
              Marketplace, and shall not copy, in whole or in part, the look and
              feel or content of the See Sight Tours Marketplace or Agent
              Marketplace, except as permitted under this Agreement, or
              otherwise authorized by See Sight Tours in writing. You shall make
              all Travel Product Information non-indexable by search engines.
            </p>
            <p className="text-base text-justify">
              <strong>3.3</strong> See Sight Tours may make certain
              Participation Data available to you from time to time. You may
              display and/or distribute such Participation Data within your
              organization for internal business purposes only. No other
              internal or external distribution of any of the Participation Data
              is permitted. You acknowledge that you will not acquire any
              proprietary rights (including copyright and any other intellectual
              property rights) in the Participation Data and/or any of the
              Services, all of which shall be retained by See Sight Tours.
            </p>
            <p className="text-base text-justify">
              <strong>3.4</strong> Unless otherwise stated in the Service Terms,
              all licenses granted to you are personal to you and you may not
              assign, mortgage, charge or grant any liens or other rights in or
              to the licensed rights or otherwise transfer or sublicense the
              licensed rights without the prior written consent of See Sight
              Tours.
            </p>
            <p className="text-base text-justify">
              <strong>3.5</strong> You agree and acknowledge that all requests
              to purchase a Travel Product are subject to acceptance by See
              Sight Tours, in accordance with the terms and conditions specified
              on the See Sight Tours Marketplace or Agent Marketplace. Travel
              Products are subject to cancellation, restrictions and penalties,
              which vary and are detailed in the Travel Product Information for
              each Travel Product.
            </p>
            <p className="text-base text-justify">
              <strong>3.6</strong> You will not register any domain name(s)
              containing the word See Sight Tours (or any similar misspelling
              of) nor contain any words relating to See Sight Tours. You are not
              authorized (directly or indirectly) to purchase, acquire, use or
              integrate trademarked terms or keywords (including variations and
              misspellings) that are identical or strikingly similar to those
              used by the other party or affiliates, or any related
              internet-domain names in association with advertising through paid
              search entries or other forms of online-advertising on platforms
              of third parties. Without prejudice to the generality of the
              foregoing, you are not permitted to engage in any use of See Sight
              Tours’s name or brand, including but not limited to use in any
              keyword brand bidding and/or the practice generally known as ‘ad
              hijacking’.
            </p>
            <p className="text-base text-justify">
              <strong>3.7</strong> Each party grants to the other party the
              right to display that party’s names, logos, marks and trademarks
              only for the purpose of advertising the distribution partnership
              as permitted hereunder, identifying the source of the Travel
              Product Information and the parties’ responsibility for Customer
              service, or for similar commercially reasonable purposes.
              Notwithstanding the foregoing, you will submit to us all proposed
              uses of our names, logos, marks and/or trademarks, and will not
              publish or otherwise engage in any use the same without our prior
              written consent.
            </p>
            <p className="text-base text-justify">
              <strong>3.8</strong> You acknowledge and agree that See Sight
              Tours’s and its affiliated websites may implement mechanisms that
              allow Customers to rate and provide feedback, reviews and
              commentary regarding the Travel Products, and agree that all such
              ratings, feedback, reviews and commentary are (as between the
              parties) owned by See Sight Tours.
            </p>
            <p className="text-base text-justify">
              <strong>3.9</strong> You shall enact and display on all Partner
              Sites at all times during the Term a notice and takedown procedure
              (“NTP”). Your NTP must require that a notification of claimed
              infringement be a written communication provided to:
              <ol className="ml-5">
                <li>
                  (a) your designated agent (referred to further in Section
                  3.9), to the extent that any Partner Site is hosted in the US;
                  and/or
                </li>
                <li>
                  (b) you directly, to the extent that any Partner Site is
                  hosted outside the US.
                </li>
              </ol>
              Your NTP must also require that such written communication
              contains all of the minimum requirements set out in applicable law
              (including but not limited to the Digital Millennium Copyright Act
              of 1998 (“DMCA”), and the Electronic Commerce Directive 2000, as
              implemented).
            </p>

            <p className="text-base text-justify">
              <strong>3.10</strong> In respect of any Partner Site hosted in the
              US, you shall:
              <ol className="ml-5">
                <li>
                  (a) designate an agent for service of copyright claims:
                  <ol className="ml-5">
                    <li>(i) on such Partner Site(s); and</li>
                    <li>
                      (ii) in an online filing with U.S. Copyright Office;
                    </li>
                  </ol>
                </li>
                <li>
                  (b) write, adopt, and post on each such Partner Site a “repeat
                  infringer policy”, in accordance with the requirements of the
                  DMCA.
                </li>
              </ol>
            </p>

            <p className="text-base text-justify">
              <strong>3.11</strong> If at any time you receive a legal complaint
              regarding a picture or text that has been provided by See Sight
              Tours, you shall immediately (a) notify See Sight Tours of the
              existence and detail of such complaint by email to{' '}
              <a
                href="mailto:Info@see sight tours.com"
                className="text-blue-500 underline"
              >
                Info@see sight tours.com
              </a>
              , and (b) promptly provide all relevant information and assistance
              regarding the claim to See Sight Tours as may be requested.
            </p>
            <p id="image-upload-section" className="text-base text-justify">
              <strong>3.12</strong> By uploading or submitting any images,
              videos, or other content to See Sight Tours, you confirm that you
              own the content or have permission to use it. You grant See Sight
              Tours a worldwide, royalty-free license to use, display, and share
              the content across all media for marketing and promotional
              purposes, without any further approval or compensation.
            </p>
          </div>
          <div className="flex flex-col gap-3 mt-3">
            <h2 className="text-md  underline ">4. Representations</h2>
            <p className="text-base text-justify">
              <strong>4.1</strong> You represent and warrant to us that:
              <ol className="ml-5">
                <li>
                  (a) you have full power and authority to execute and deliver
                  this Agreement, and have all licenses, authorizations,
                  consents, approvals and permits required by all applicable
                  laws and regulations in order to perform your obligations and
                  exercise your rights hereunder; and
                </li>
                <li>
                  (b) you shall comply with all applicable international,
                  federal, state and local laws and regulations (including but
                  not limited to consumer protection and data privacy laws).
                </li>
              </ol>
              If you are using the Services as a corporate entity, you further
              represent and warrant that such entity is duly organized and
              validly existing in accordance with the laws of the state (or
              country) of its incorporation, that it has full corporate power
              and authority to execute and deliver this Agreement and has all
              licenses, authorizations, consents, approvals and permits required
              by all applicable laws and regulations in order to perform its
              obligations hereunder. You agree that you will not do or omit to
              do any act that, in See Sight Tours's sole opinion, may be likely
              to cause See Sight Tours or the See Sight Tours Marketplace or
              Agent Marketplace to be disparaged, defamed, discredited or
              brought into disrepute.
            </p>

            <p className="text-base text-justify">
              <strong>4.2</strong> Each party represents and warrants that:
              <ol className="ml-5">
                <li>
                  (a) this Agreement constitutes a legal, valid and binding
                  obligation upon it, enforceable in accordance with its terms
                  by appropriate legal remedy; and
                </li>
                <li>
                  (b) the execution, delivery and performance of this Agreement
                  by such party does not conflict with any agreement, instrument
                  or understanding to which it is a party or by which it may be
                  bound, nor violate any law or regulation of any court,
                  governmental body or other agencies having jurisdiction over
                  it.
                </li>
              </ol>
            </p>

            <div className="flex flex-col gap-3 mt-3">
              <h2 className="text-md  underline ">5. Indemnification</h2>
              <p className="text-base text-justify">
                You will indemnify and hold harmless, and at See Sight Tours's
                request defend, See Sight Tours (including without limitation
                all companies in the See Sight Tours group and See Sight Tours's
                affiliates) and any of their respective directors, officers,
                employees, agents, suppliers, licensors, vendors, distributors
                and service providers (each a "See Sight Tours Indemnified
                Party") from and against any and all claims, losses,
                liabilities, damages, fines, penalties, settlements, expenses,
                and costs (including attorneys' fees and court costs) incurred
                or suffered by a See Sight Tours Indemnified Party in connection
                with any third party claim, suit, demand, action, or
                investigation brought against a See Sight Tours Indemnified
                Party directly or indirectly arising out of or relating to your
                breach (or a claim that, if true, would be a breach) of this
                Agreement, including, without limitation, any and all of your
                representations and warranties in this Agreement.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">6. Disclaimer</h2>
              <p className="text-base text-justify">
                EXCEPT AS SPECIFICALLY PROVIDED IN THIS AGREEMENT, See Sight
                Tours DOES NOT MAKE, AND EXPRESSLY DISCLAIMS, ANY
                REPRESENTATIONS OR WARRANTIES IN CONNECTION WITH THE TRAVEL
                PRODUCTS, TRAVEL PRODUCT INFORMATION, TRAVEL PRODUCT LINKS, See
                Sight Tours MARKETPLACE, AGENT MARKETPLACE OR OTHER SUBJECT
                MATTER UNDER THIS AGREEMENT, WHETHER EXPRESS, IMPLIED, STATUTORY
                OR OTHERWISE, INCLUDING, WITHOUT LIMITATION, WARRANTIES OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-
                INFRINGEMENT OF THIRD PARTY RIGHTS, TITLE, ANY WARRANTIES
                ARISING OUT OF A COURSE OF PERFORMANCE, DEALING OR TRADE USAGE.
                See Sight Tours DOES NOT GUARANTEE THAT THE TRAVEL PRODUCT
                INFORMATION, TRAVEL PRODUCT LINKS, REFERRAL LINKS, See Sight
                Tours APIS, PARTICIPATION DATA, See Sight Tours MARKETPLACE OR
                AGENT MARKETPLACE WILL BE ALWAYS AVAILABLE, ACCESSIBLE, TIMELY,
                OR ERROR-FREE. See Sight Tours MAKES NO GUARANTEE, WARRANTY OR
                REPRESENTATION AS TO THE AMOUNT OF COMMISSION THAT MAY BE
                GENERATED BY YOU PURSUANT TO THIS AGREEMENT.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                7. Limitation of Liability
              </h2>
              <p className="text-base text-justify">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, NEITHER PARTY WILL BE
                LIABLE TO THE OTHER PARTY OR ANY THIRD PARTY FOR ANY INDIRECT,
                INCIDENTAL, EXEMPLARY OR CONSEQUENTIAL LOSS OR PUNITIVE DAMAGES
                UNDER ANY CIRCUMSTANCES, INCLUDING, BUT NOT LIMITED TO, LOSS OF
                REVENUES OR LOSS OF PROFITS, OR COSTS TO PROCURE SUBSTITUTE
                GOODS, EVEN IF ADVISED OF THE RISK OF THE LOSS OR DAMAGES IN
                ADVANCE. TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR AGGREGATE
                LIABILITY TO YOU WILL NOT EXCEED $10,000. NONE OF THE FOREGOING
                LIMITATIONS SHALL APPLY TO YOUR BREACH OF SECTIONS 8, 9 OR THE
                TERMS OF ANY LICENSE, OR YOUR INDEMNIFICATION OBLIGATIONS UNDER
                THIS AGREEMENT, FOR WHICH LIABILITY SHALL IN EACH CASE BE
                UNLIMITED.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">8. Confidentiality</h2>
              <p className="text-base text-justify">
                During the course of your use of the Services, you may receive
                confidential and/or proprietary information relating to us, our
                corporate group, and/or to the Services that is not known to the
                general public (including, without limitation, all information
                pertaining to Commissions, the See Sight Tours Marketplace, the
                Agent Marketplace, and the terms of this Agreement)
                (“Confidential Information”). You agree that:
                <ol className="ml-5">
                  <li>
                    (a) all Confidential Information will remain See Sight
                    Tours’s exclusive property;
                  </li>
                  <li>
                    (b) you will use Confidential Information only as is
                    reasonably necessary for your participation in the Services;
                  </li>
                  <li>
                    (c) you will not directly or indirectly (including through a
                    third party) otherwise disclose Confidential Information to
                    any individual, company, or other third party; and
                  </li>
                  <li>
                    (d) you will take all reasonable measures to protect the
                    Confidential Information against any use or disclosure that
                    is not expressly permitted in this Agreement.
                  </li>
                </ol>
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                9. Privacy; Data Security.
              </h2>
              <p className="text-base text-justify">
                Each party shall ensure that any collection, use and disclosure
                of Customer Information obtained by such party pursuant to this
                Agreement complies with Data Protection Laws. Neither party
                shall send any unsolicited commercial email or other online
                communication (e.g., "spam") to Customers. You shall take all
                appropriate measures to secure the confidentiality of Customer
                Information in your possession and to protect such Customer
                Information from unauthorized use or disclosure. If either party
                shares any personal data (whether Customer Information or
                otherwise) with the other party pursuant to this Agreement, the
                following terms shall apply:
              </p>
              <p
                id="phone-number-security"
                className="text-base text-justify font-semibold"
              >
                Your phone number is required to send important booking updates
                and information. We keep your phone number safe and only use it
                for this purpose. By providing your phone number, you consent to
                its use as part of the booking process, as a booking cannot be
                created without it.
              </p>
              <p className="text-base text-justify">
                <strong>9.1</strong> Each party shall only process the personal
                data in accordance with the Data Protection Laws, including:
                <ol className="ml-5">
                  <li>
                    (a) process the personal data lawfully, fairly and in a
                    transparent manner in relation to the data subjects;
                  </li>
                  <li>
                    (b) treat the personal data as confidential and ensure that
                    its employees will treat the personal data as confidential;
                  </li>
                  <li>
                    (c) only process the personal data for limited and specified
                    purposes;
                  </li>
                  <li>
                    (d) not retain the personal data for longer than is
                    necessary to carry out the purposes for which it has
                    obtained the personal data; and
                  </li>
                  <li>
                    (e) implement appropriate security measures to protect the
                    personal data, including appropriate technical and
                    organizational measures, to protect against unauthorized or
                    unlawful processing and against accidental loss, destruction
                    or damage, including inter alia:
                    <ol className="ml-5">
                      <li>
                        (i) the pseudonymisation and encryption of the personal
                        data;
                      </li>
                      <li>
                        (ii) the ability to ensure the ongoing confidentiality,
                        integrity, availability and resilience of processing
                        systems and services;
                      </li>
                      <li>
                        (iii) the ability to restore the availability and access
                        to the personal data in a timely manner in the event of
                        a physical or technical incident; and
                      </li>
                      <li>
                        (iv) a process for regularly testing, assessing and
                        evaluating the effectiveness of technical and
                        organizational measures for ensuring the security of the
                        processing.
                      </li>
                    </ol>
                  </li>
                </ol>
              </p>

              <p className="text-base text-justify">
                <strong>9.2</strong>Where either party becomes aware of
                inaccuracies of the personal data received from the other party,
                it will notify the other party thereof.
              </p>
              <p className="text-base text-justify">
                <strong>9.3</strong> Each party may transfer the personal data
                outside the European Economic Area if it complies with the
                provisions of the Data Protection Laws on the transfer of
                personal data to third countries.
              </p>
              <p className="text-base text-justify">
                <strong>9.4</strong> Each party will hold the other party
                harmless of any claims, damages, penalties and any costs or
                fees, of whatever nature incurred by the party or for which the
                party may become liable due to any failure by the other party or
                its employees or agents to comply with any of its obligations
                under this Section 9, or any Data Protection Laws.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">10. Force majeure</h2>
              <p className="text-base text-justify">
                We will not be liable for any delay or failure to perform any of
                our obligations under this Agreement by reasons, events or other
                matters beyond our reasonable control.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                11. Entire Agreement; Modifications; Waivers.
              </h2>
              <p className="text-base text-justify">
                This Agreement constitutes the entire agreement between the
                parties pertaining to its subject matter, and supersedes all
                prior and contemporaneous agreements, arrangements and
                understandings between the parties with respect to such subject
                matter. We may amend any of the terms and conditions contained
                in this Agreement (including any of the Service Terms) at any
                time and at our sole discretion. Any changes will be effective
                upon the posting of such changes on the See Sight Tours Partner
                Program platform or otherwise upon notification to you by any
                means, and you are responsible for reviewing and informing
                yourself of all applicable changes or notices. YOUR CONTINUED
                USE OF ANY SERVICE AFTER See Sight Tours’s POSTING OF ANY
                CHANGES WILL CONSTITUTE YOUR ACCEPTANCE OF SUCH CHANGES OR
                MODIFICATIONS. In no event will a waiver of any right hereunder
                constitute the waiver of the right in a future instance unless
                the waiver so specifies in writing. Any modification, amendment,
                or waiver effected in accordance with this Section shall be
                binding upon each of the Parties, and each of their respective
                successors and assigns.
              </p>
            </div>
            <div className="flex flex-col gap-3 ">
              <h2 className="text-md  underline ">12. No Assignment.</h2>
              <p className="text-base text-justify">
                You may not assign this Agreement in whole or in part or
                delegate any of its right or obligations hereunder without See
                Sight Tours's prior written consent. Any attempted assignment in
                violation of the foregoing will be null and void. Subject to the
                foregoing, this Agreement will bind and insure to the benefit of
                each party's successors and permitted assigns.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">13. Severability.</h2>
              <p className="text-base text-justify">
                If one or more provisions of this Agreement are held to be
                unenforceable under applicable law the parties agree to
                renegotiate the provision in good faith. In the event the
                parties cannot reach a mutually agreeable and enforceable
                replacement for the provision, then:
                <ol className="ml-5">
                  <li>
                    (i) the provision shall be excluded from this Agreement;
                  </li>
                  <li>
                    (ii) the balance of this Agreement shall be interpreted as
                    if the provision were so excluded; and
                  </li>
                  <li>
                    (iii) the balance of this Agreement shall be enforceable in
                    accordance with its terms.
                  </li>
                </ol>
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">14. Publicity.</h2>
              <p className="text-base text-justify">
                You may not issue a press release, advertisement or public
                statement concerning the existence or contents of this Agreement
                or the relationship of the parties without the prior written
                consent of See Sight Tours. Notwithstanding the foregoing, See
                Sight Tours may issue a press release, advertisement or public
                statement referencing you as a member of the See Sight Tours
                Partner Program (or user of any of the Services).
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                15. Relationship of the Parties.
              </h2>
              <p className="text-base text-justify">
                The relationship created by this Agreement is solely that of
                independent contractors and the parties hereby acknowledge and
                agree that nothing in this Agreement will be deemed to
                constitute either party as an employee or an agent of the other
                party. This Agreement will not be construed as constituting a
                partnership or create any other form of joint venture. Neither
                party will have any power or express or implied authorization to
                bind the other party or to assume or to create any obligation or
                responsibility, express or implied, on behalf of the other party
                or in the other party's name. You will not make any statement,
                whether on your site or otherwise, that would contradict
                anything in this section.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">16. Notices.</h2>
              <p className="text-base text-justify">
                Unless otherwise provided herein, all notices under this
                Agreement from you to See Sight Tours shall be in writing and
                shall be delivered to the address set forth below, and such
                notices shall be deemed to have been given upon receipt.
                Notwithstanding the foregoing, See Sight Tours may provide
                notices to you via email or by other online messaging tools in
                connection with amendments to this Agreement or otherwise (with
                such notices deemed to have been given upon sending/posting):
              </p>
              <p>See Sight Tours, Inc.</p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">17. Dispute Resolution.</h2>
              <p className="text-base text-justify">
                Any controversy, claim or dispute arising out of or relating to
                this Agreement, or the obligation of a party hereunder will be
                settled exclusively in accordance with Section 17 and 18,
                whether based in contract, tort, statute, fraud,
                misrepresentation or any other legal theory. The English
                language version of this Agreement shall govern and all
                proceedings conducted shall be conducted in English.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                18. Governing Law and Jurisdiction.
              </h2>
              <p className="text-base text-justify">
                This Agreement and the rights and obligations of the parties
                will be construed in accordance with and governed by the laws of
                the State of Delaware. You hereby consent to the exclusive
                jurisdiction and venue of courts located in Delaware.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                19. General Terms Definitions
              </h2>
              <p className="text-base text-justify">
                <strong>19.1</strong>"Agent Marketplace” means See Sight Tours’s
                booking platform for use by Agents (as defined in the applicable
                Service Terms), which may be accessible via travel agents.See
                Sight Tours.com or such other URL that See Sight Tours may
                update from time to time.
              </p>
              <p className="text-base text-justify">
                <strong>19.2</strong>“Commission” means the commission payable
                by See Sight Tours to you as further described in the applicable
                Service Terms.
              </p>
              <p className="text-base text-justify">
                <strong>19.3</strong> “Commission Rate” means the percentage
                rate of Commission either as set forth in the applicable Service
                Terms, or as otherwise specified in your See Sight Tours Partner
                Program Account.
              </p>
              <p className="text-base text-justify">
                <strong>19.4</strong> “Customer” means a person who purchases a
                Travel Product pursuant to the applicable Service Terms.
              </p>
              <p className="text-base text-justify">
                <strong>19.5</strong> “Customer Information” means personally
                identifiable information of individual Customers, including
                name, address, phone number, e-mail address, date of birth,
                social security number, credit card information, driver's
                license number, account numbers, PINs and/or passwords, and any
                other information that could reasonably identify a person or
                entity.
              </p>
              <p className="text-base text-justify">
                <strong>19.6</strong> “Data Protection Laws” means all
                applicable laws, regulations and standards relating to data
                protection and privacy, including but not limited to Regulation
                (EU) 2016/679.
              </p>
              <p className="text-base text-justify">
                <strong>19.7</strong> “End User” means a person who uses a
                Partner Site.
              </p>
              <p className="text-base text-justify">
                <strong>19.8</strong> “Minimum Payment Threshold” means fifty
                United States dollars (US$50.00).
              </p>
              <p className="text-base text-justify">
                <strong>19.9</strong> “Participation Data” means any
                information, analytics, content and/or intelligence that is made
                available to you through your use of the See Sight Tours Partner
                Program.
              </p>
              <p className="text-base text-justify">
                <strong>19.10</strong>“Partner Site” means any website,
                platform, channel and/or application owned, operated and
                maintained by you.
              </p>
              <p className="text-base text-justify">
                <strong>19.11</strong>“Reservation” means the purchase of a
                Travel Product by a Customer.
              </p>
              <p className="text-base text-justify">
                <strong>19.12</strong>“Retail Rate” means the rate for retail
                sale of a Travel Product to a Customer via the See Sight Tours
                Marketplace.
              </p>
              <p className="text-base text-justify">
                <strong>19.13</strong> “Supplier” means the third-party provider
                of a Travel Product.
              </p>
              <p className="text-base text-justify">
                <strong>19.14</strong> “Travel Product” means a travel- and/or
                tourism-related tour, excursion, activity, venue, ticket,
                experience and/or related service.
              </p>
              <p className="text-base text-justify">
                <strong>19.15</strong> “Travel Product Information” means any
                information related to a Travel Product provided to you by See
                Sight Tours under this Agreement.
              </p>
              <p className="text-base text-justify">
                <strong>19.16</strong> “Undesirable Material” means any material
                that a reasonable person may regard as offensive or that is
                illegal including, but not limited to defamatory or potentially
                defamatory, abusive or indecent material, expressions of
                bigotry, racism, sexism, ageism, hatred or profanity,
                information about illegal activities, material promoting harm or
                injury to any group or individual, any material likely to breach
                confidence, copyright, privacy and other rights and/or any
                material that is defined as prohibited content or potentially
                prohibited content or is illegal content under applicable laws
                in any jurisdiction.
              </p>
              <p className="text-base text-justify">
                <strong>19.17</strong> “See Sight Tours Marketplace” means the
                online marketplace operated by See Sight Tours on which Travel
                Products are marketed and made available to purchase.
              </p>
              <p className="text-base text-justify">
                <strong>19.18</strong> “See Sight Tours Terms and Conditions”
                means the terms and conditions hosted at{' '}
                <a
                  className="text-blue-500 underline"
                  target="_blank"
                  href={`https://www.seesight-tours.com/terms-and-conditions`}
                  rel="noreferrer"
                >
                  https://www.seesight-tours.com/terms-and-conditions
                </a>{' '}
                or via such other link as See Sight Tours may determine on the
                See Sight Tours Marketplace or Agent Marketplace.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                [A] See Sight Tours AGENT PROGRAM SERVICE TERMS
              </h2>
              <p className="text-base text-justify">
                The See Sight Tours Agent Program is a Service that enables
                Agents (as defined in these Service Terms) to access the Agent
                Marketplace for the purpose of purchasing Travel Products on
                behalf of Customers, and/or of sending Referral Links to
                Customers to facilitate their purchases on the See Sight Tours
                Marketplace, and to earn Commissions from See Sight Tours.
              </p>
              <p>
                These Service Terms are part of the See Sight Tours Partner
                Program Agreement but, unless specifically provided otherwise,
                concern and apply only to your participation in the See Sight
                Tours Agent Program. Unless defined in these Service Terms, all
                capitalized terms have the meanings given to them in the See
                Sight Tours Partner Program Agreement.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                A-1 Sponsoring Agents, Affiliated Agents and Unaffiliated
                Agents.
              </h2>
              <p className="text-base text-justify">
                <strong>A-1.1</strong> Overview. There are three categories of
                Agents permitted by See Sight Tours to participate in the See
                Sight Tours Agent Program: Sponsoring Agents, Affiliated Agents
                and Unaffiliated Agents. If See Sight Tours authorizes you to
                permit Affiliated Agents to process Transactions under your See
                Sight Tours Partner Program Account, then you are a Sponsoring
                Agent. If you have been invited by a Sponsoring Agent to
                register for use of the Agent Marketplace and/or are authorized
                by a Sponsoring Agent to process Transactions on their Agent
                Marketplace account, then you are an Affiliated Agent. If
                neither of the foregoing categories apply to you, then you are
                an Unaffiliated Agent.
              </p>
              <p className="text-base text-justify">
                <strong>A-1.2</strong> Provisions Applicable Only to Sponsoring
                Agents. If you are a Sponsoring Agent, then you agree to the
                following:
              </p>

              <p className="text-base text-justify">
                <strong>A-1.2.1 </strong>Use of Your Agent Marketplace Account.
                You are responsible for any use of your Agent Marketplace
                account, including with respect to any access or use of your
                account by your Affiliated Agents.
              </p>
              <p className="text-base text-justify">
                <strong>A-1.2.2 </strong>Commercial Terms and Commissions. You
                are also solely responsible for determining any commercial terms
                between you and your Affiliated Agents with respect to
                Transactions processed by such Affiliated Agents under your
                Agent Marketplace account, including the amount of and payment
                terms applicable to commissions or other fees, if any.
                Affiliated Agents shall look solely to you, and not See Sight
                Tours, for any payments related to Transactions processed under
                your Agent Marketplace account.
              </p>
              <p className="text-base text-justify">
                <strong>A-1.3 </strong>Provisions Applicable Only to Affiliated
                Agents. If you are an Affiliated Agent, then you agree to the
                following:
              </p>
              <p className="text-base text-justify">
                <strong>A-1.3.1 </strong>Use of Sponsoring Agent’s Agent
                Marketplace Account. Your use of your Sponsoring Agent’s Agent
                Marketplace account is subject to:
                <ol className="ml-5">
                  <li>(a) your Sponsoring Agent’s continuing authorization,</li>
                  <li>
                    (b) your Sponsoring Agent’s continuing good standing under
                    the See Sight Tours Agent Partner Program, and
                  </li>
                  <li>(c) your compliance with the terms of this Agreement.</li>
                </ol>
                You acknowledge and agree that your access to your Sponsoring
                Agent’s Agent Marketplace Account may be rescinded by your
                Sponsoring Agent at any time, in their sole discretion.
              </p>

              <p className="text-base text-justify">
                <strong>A-1.3.2 </strong>Commercial Terms and Commissions. You
                are solely responsible for determining any commercial terms
                between you and your Sponsoring Agent with respect to
                Transactions processed by you under their Agent Marketplace
                account, including the amount of and payment terms applicable to
                commissions or other fees, if any. You shall look solely to your
                Sponsoring Agent, and not See Sight Tours, for any payments
                related to Transactions processed by you under your Sponsoring
                Agent’s Agent Marketplace account.
              </p>
              <p className="text-base text-justify">
                <strong>A-1.3.3 </strong>Provisions Inapplicable to Affiliated
                Agents. The following provisions of this Agreement are
                inapplicable to you: A-6 (Commissions; Payment), and A-9
                (Insurance). You acknowledge and agree that the remaining
                provisions of this Agreement are applicable to you.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-2 Referral Links</h2>
              <p className="text-base text-justify">
                <strong>A-2.1 </strong>See Sight Tours may make Referral Links
                available to you for use as described in this Agreement. You
                shall not modify the Referral Links in any way. See Sight Tours
                shall not be responsible for errors that occur in the tracking
                of Referred Transactions if you have made, or caused, any such
                modification. You acknowledge and agree that it is your
                responsibility to properly format all Referral Links.
              </p>
              <p className="text-base text-justify">
                <strong>A-2.2 </strong>You shall only post or share Referral
                Links on your own website and/or social media pages/feeds
                controlled by you. You may use Referral Links within e-mails,
                but solely to the extent that such emails are sent by you to
                persons who have provided you with explicit consent to receive
                such emails.
              </p>
              <p className="text-base text-justify">
                <strong>A-2.3 </strong>See Sight Tours may at any time, without
                prior notice, remove any or all Referral Links, require you to
                remove any or all Referral Links, or modify any or all Referral
                Links.
              </p>
              <p className="text-base text-justify">
                <strong>A-2.4 </strong>See Sight Tours will pay you Commissions
                on Referred Transactions, subject to the exclusions set out
                below and in accordance with these Service Terms and the terms
                of the Agreement. A “Referred Transaction” occurs when:
                <ol className="ml-5">
                  <li>
                    (a) a person clicks through a Referral Link to the See Sight
                    Tours Marketplace, and
                  </li>
                  <li>
                    (b) during the same user session, that person purchases a
                    Travel Product (thereby becoming a Customer).
                  </li>
                </ol>
                If a person initially visits the See Sight Tours Marketplace
                using a Referral Link, any Travel Product purchase completed by
                such person within thirty (30) days (whether or not made via a
                Referral Link) will count as a Referred Transaction if it
                otherwise meets the requirements of this Agreement, including
                but not limited to the provisions of Section A-2.5.
              </p>

              <p className="text-base text-justify">
                <strong>A-2.5 </strong>See Sight Tours does not accept
                responsibility for persons who may delete or otherwise not
                accept cookies used to track return visits to the See Sight
                Tours Marketplace after a person’s initial visit via a Referral
                Link, and See Sight Tours shall not be required to pay
                Commissions in respect of purchases made during any untracked
                return visits. In addition, See Sight Tours shall not pay
                Commissions in respect of purchases made by a person who
                revisits the See Sight Tours Marketplace during the thirty (30)
                day period referred to in Section A-2.4 but:
                <ol className="ml-5">
                  <li>
                    (a) whose last click prior to landing on the See Sight Tours
                    Marketplace is another Internet site, search engine, social
                    media site, advertisement and/or link; or
                  </li>
                  <li>
                    (b) who clicked on a link belonging to one of See Sight
                    Tours’s distribution partners prior to clicking on a
                    Referral Link in circumstances where (due to See Sight
                    Tours’s pre-existing commercial relationship with such
                    distribution partner) the purchase is attributed to the
                    distribution partner rather than you.
                  </li>
                </ol>
                You acknowledge and agree that all tracking and reporting shall
                be conducted by See Sight Tours, and only See Sight Tours’s
                tracking and reporting data will be used to determine whether
                Commissions are payable to you.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-3 License</h2>
              <p className="text-base text-justify">
                <strong>A-3.1 </strong>Subject to the terms and conditions of
                this Agreement, See Sight Tours hereby grants to you a
                royalty-free, world- wide, limited, non-transferable,
                non-sublicensable, non-assignable, non-exclusive license during
                the term of these See Sight Tours Agent Program Service Terms to
                access and use the Agent Marketplace and See Sight Tours
                Marketplace and, subject to Section 3.1 of the General Terms,
                use,reproduce, distribute and display the Travel Product
                Information solely for the limited purpose of promoting and
                facilitating the purchase of Travel Products by or on behalf of
                Customers.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-4 Transactions</h2>
              <p className="text-base text-justify">
                <strong>A-4.1 </strong>Transaction Confirmation. Upon completion
                of a Transaction, See Sight Tours will provide the Customer
                (and/or you, as applicable) with an electronic acknowledgment
                and Ticket for such Transaction.
              </p>

              <p className="text-base text-justify">
                <strong>A-4.2</strong> Conditions of Your Purchasing as
                Customer’s Agent. You may enter into a Transaction on behalf of
                a Customer, provided that you shall in every case:
                <ol className="ml-5">
                  <li>
                    (a) notify the Customer that the See Sight Tours Terms and
                    Conditions shall govern such Customer’s receipt and use of
                    all Travel Products purchased in connection with such
                    Transaction and provide all of the Travel Product
                    Information applicable to such Travel Products, so as to
                    effectively incorporate (in the manner required by
                    applicable law) the See Sight Tours Terms and Conditions and
                    Travel Product Information into the contract for sale of
                    such Travel Product; and
                  </li>
                  <li>
                    (b) not make or give any representations, warranties or
                    other promises concerning a Travel Product beyond those
                    contained in the See Sight Tours Terms and Conditions and
                    the applicable Travel Product Information.
                  </li>
                </ol>
              </p>

              <p className="text-base text-justify">
                <strong>A-4.3 </strong>Payment for Transactions. See Sight
                Tours, acting solely as the applicable Supplier’s payment
                processing agent, will be the merchant of record for all
                Transactions and will be responsible for charging and collecting
                all amounts payable for Transactions from Customers and/or you.
                See Sight Tours shall be responsible for all credit card
                merchant fees and credit card chargebacks associated with a
                Transaction. See Sight Tours shall be responsible for all
                payments to Suppliers for Travel Products. See Sight Tours or
                the applicable Supplier shall be responsible for paying any
                federal, state or local taxes imposed by applicable government
                entities with respect to Transactions, other than any taxes
                applicable to your receipt of Commissions.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-5 Support</h2>
              <p className="text-base text-justify">
                <strong>A-5.1 </strong>See Sight Tours will provide you and
                Customers with email-based support for the purpose of responding
                to and resolving issues associated with a Travel Product or
                Transaction.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-6 Commissions; Payment</h2>
              <p className="text-base text-justify">
                <strong>A-6.1 </strong>Subject to Sections A-6.2 and A-7, if you
                are a Sponsoring Agent or an Unaffiliated Agent, See Sight Tours
                shall pay you a Commission of twelve percent (12%) of the Retail
                Rate of each Travel Product that is included in a Transaction
                (including Referred Transactions), net of all cancellations and
                partial or full refunds.
              </p>
              <p className="text-base text-justify">
                <strong>A-6.2 </strong>See Sight Tours may, in its sole
                discretion, enter into an incentive agreement with you with
                respect to any additional fees to be paid to you pursuant to
                this Agreement.
              </p>
              <p className="text-base text-justify">
                <strong>A-6.3 </strong>Commissions shall be paid via Electronic
                Funds Transfer or any other method approved by See Sight Tours
                in the month following the calendar month in which each Travel
                Product purchased in a Transaction is availed. In the event the
                total amount of Commissions due in any month is less than the
                Minimum Payment Threshold then payment will be withheld until
                the earlier of:
                <ol className="ml-5">
                  <li>
                    (a) such time as the total Commissions due (including the
                    previously withheld amount) in a subsequent calendar month
                    are equal to or greater than the Minimum Payment Threshold,
                    or
                  </li>
                  <li>(b) the termination of this Agreement.</li>
                </ol>
              </p>

              <p className="text-base text-justify">
                <strong>A-6.4 </strong>You acknowledge and agree that it is your
                responsibility to provide See Sight Tours with accurate and
                complete payment information, and that See Sight Tours has no
                obligation to pay you any Commissions unless or until you have
                provided such information.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-7 Effect of Termination</h2>
              <p className="text-base text-justify">
                <strong>A-7.1 </strong>Upon termination of these Service Terms
                or this Agreement for any reason, all licenses and rights
                granted to you pursuant to the Agreement will immediately
                terminate, and you shall cease using the Agent Marketplace and
                See Sight Tours Marketplace. You shall not be entitled to
                receive any Commissions in respect of Transactions that occur
                after the termination date. Notwithstanding the foregoing, if
                See Sight Tours terminates these Service Terms or this Agreement
                due to your breach (or if See Sight Tours has reason to believe
                there has been such a breach), you shall not be entitled to
                receive any Commissions that may otherwise have been payable
                after the termination date, including for Transactions made
                prior to the date of termination. Sections A-10 (Definitions),
                A-1.2 (Provisions Applicable Only to Sponsoring Agents), A-1.3
                (Provisions Applicable Only to Affiliated Agents),
                A-6(Commissions: Payment) and A-8 (Indemnity) shall survive any
                termination or expiration of this Agreement.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-8 Indemnity</h2>
              <p className="text-base text-justify">
                <strong>A-8.1 </strong>In addition to the indemnification
                obligations set forth in the General Terms, if you are a
                Sponsoring Agent, such obligations shall also apply to any and
                all claims, losses, liabilities, damages, fines, penalties,
                settlements, expenses, and costs (including attorneys’ fees and
                court costs) incurred or suffered by a See Sight Tours
                Indemnified Party in connection with any third party claim,
                suit, demand, action, or investigation brought against a See
                Sight Tours Indemnified Party directly or indirectly arising out
                of or relating to any breach (or a claim that, if true, would be
                a breach) of the Agreement by any of your Affiliated Agents.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-9 Insurance</h2>
              <p className="text-base text-justify">
                <strong>A-9.1 </strong>You will procure and maintain a current
                Public (Product) liability insurance (PLI) and errors and
                omissions insurance with coverage limits consistent with
                industry standards and as may be required by applicable laws,
                rules, and regulations. Such insurance will be provided through
                an insurer acceptable to See Sight Tours with an A.M. Best (or
                its equivalent) financial strength rating of A-VII or higher,
                and will include, without limitation, completed operations,
                blanket contractual liability, and personal injury and
                advertising liability. You will add See Sight Tours as an
                additional insured to such insurance policies and will provide a
                certificate of insurance evidencing all of the coverage
                described in this Section A-9 and that See Sight Tours has been
                added as an additional insured. Such insurance carried by you
                will be primary to any insurance carried by See Sight Tours and
                if you are a Sponsoring Agent, such insurance will provide
                coverage for your Affiliated Agents to the same extent as you.
                Notwithstanding the foregoing, See Sight Tours reserves the
                right to require specific additional coverage or increased
                coverage, or to waive the foregoing insurance requirements, and
                you will maintain your insurance at such levels upon See Sight
                Tours’s request. Such coverage and limits will not be deemed to
                be a limitation on your liability to See Sight Tours, if any,
                arising under this Agreement.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">A-10 Vehicle Insurance</h2>
              <p className="text-base text-justify">
                <strong>A-10.1 </strong>As a guide providing tours through See
                Sight Tours's platform, you are required to maintain valid and
                adequate vehicle insurance for any vehicle used during tours.
                This vehicle insurance should meet the following criteria:
              </p>

              <div className="ml-5">
                <li>
                  <strong>Comprehensive Coverage:</strong> The insurance must
                  provide comprehensive coverage for the vehicle against
                  damages, theft, accidents, and any other relevant risks.
                </li>

                <li>
                  <strong>Third-Party Liability:</strong> The insurance policy
                  should include third-party liability coverage to protect
                  against claims or damages arising from accidents involving the
                  vehicle during tours.
                </li>

                <li>
                  <strong>Coverage Limits:</strong> The coverage limits for the
                  vehicle insurance should be in accordance with industry
                  standards and as required by applicable laws and regulations.
                </li>

                <li>
                  <strong>Insurance Provider:</strong> The vehicle insurance
                  must be obtained from an insurer acceptable to See Sight
                  Tours, with a strong financial strength rating (A.M. Best
                  A-VII or higher) or an equivalent rating.
                </li>

                <li>
                  <strong>Additional Insured:</strong> See Sight Tours must be
                  added as an additional insured party to the vehicle insurance
                  policy, and you must provide a certificate of insurance
                  confirming See Sight Tours's status as an additional insured.
                </li>
              </div>

              <p className="text-base text-justify">
                <strong>A-10.2 </strong>The vehicle insurance maintained by you
                will be considered primary to any insurance carried by See Sight
                Tours, and it should provide coverage for any damages or
                liabilities related to the vehicle used for tours
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                A-11 See Sight Tours Agent Service Definitions
              </h2>
              <p className="text-base text-justify">
                <strong>A-11.1</strong> “Affiliated Agent” means an Agent that
                has been authorized by a Sponsoring Agent to utilize such
                Sponsoring Agent’s Agent Marketplace account to process
                Transactions, as described more fully in Section A-1.
              </p>
              <p className="text-base text-justify">
                <strong>A-11.2</strong>“Agent” means a person acting in the
                course of business and in the manner required by applicable law
                who is engaged in marketing and/or arranging transportation,
                accommodations, tours or trips for travelers, which may include
                acting as a booking agent on behalf of such travelers.
              </p>
              <p className="text-base text-justify">
                <strong>A-11.3</strong>“Commission” means a fee paid to a
                Sponsoring Agent or Unaffiliated Agent for each Transaction in
                accordance with these Service Terms (including any additional
                fees that may be agreed between the parties pursuant to Section
                A-6).
              </p>
              <p className="text-base text-justify">
                <strong>A-11.4</strong>“Referral Link” means a unique tracking
                link that See Sight Tours may make available to you, used for
                linking to web pages on the See Sight Tours Marketplace.
              </p>
              <p className="text-base text-justify">
                <strong>A-11.5</strong> “Referred Transaction” means a
                Transaction concluded in accordance with Section A-2.4.
              </p>
              <p className="text-base text-justify">
                <strong>A-11.6</strong>“Sponsoring Agent” means an Agent that
                has been authorized by See Sight Tours to invite Affiliate
                Agents to register for access to the Agent Marketplace and
                permit such Affiliated Agents to utilize such Sponsoring Agent’s
                Agent Marketplace account to process Transactions, as described
                more fully in Section A-1.
              </p>
              <p className="text-base text-justify">
                <strong>A-11.7</strong>“Ticket” means an electronic document
                that may include the trademarks of See Sight Tours, is provided
                by See Sight Tours to a Customer in connection with the
                completion of a Transaction, contains relevant information about
                the Travel Product(s) specified in the Transaction (e.g.,
                booking-related information) and that the Customer must present
                to the applicable Supplier to redeem such Travel Product(s).
              </p>
              <p className="text-base text-justify">
                <strong>A-11.8</strong>“Transaction” means the purchase of a
                Travel Product in accordance with the terms of this Agreement,
                that is either
                <p className="ml-5">
                  (a) by you acting as a Customer’s agent, or
                </p>
                <p className="ml-5">
                  (b) by a Customer through a Referral Link, in either case on
                  behalf of one or more travelers in a single travel itinerary,
                  and where the sale is processed on the Agent Marketplace (in
                  the case of (a)) or See Sight Tours Marketplace (in the case
                  of (b)) using the access credentials or other unique
                  identifiers provided by See Sight Tours to you (if you are a
                  Sponsoring Agent or Unaffiliated Agent) or by a Sponsoring
                  Agent to you (if you are an Affiliated Agent). A Referred
                  Transaction is a type of Transaction.
                </p>
              </p>
              <p className="text-base text-justify">
                <strong>A-11.9</strong>“Unaffiliated Agent” means an Agent that
                is not a Sponsoring Agent or Affiliated Agent, as described more
                fully Section A-1.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">
                [B] See Sight Tours AFFILIATE PROGRAM SERVICE TERMS
              </h2>
              <p className="text-base text-justify">
                The See Sight Tours Affiliate Program is a Service that enables
                you to publish Travel Products and integrate Travel Products on
                the Partner Site owned and operated by you, and to generate
                Reservations in return for the payment of Commission for
                fulfilled bookings. The See Sight Tours Affiliate Program may
                also allow you to participate by receiving from See Sight Tours
                a QR code (or other similar technology) and/or unique URL
                directing to a page on the See Sight Tours Marketplace on which
                Travel Products selected by you may be published (“Affiliate
                Microsite”), and whereby fulfilled bookings made on such
                Affiliate Microsite through the corresponding Travel Product
                Links may result in Commission being paid to you. These Service
                Terms are part of the See Sight Tours Partner Program Agreement
                but, unless specifically provided otherwise, concern and apply
                only to your participation in the See Sight Tours Affiliate
                Program. Unless defined in these Service Terms, all capitalized
                terms have the meanings given to them in the See Sight Tours
                Partner Program Agreement.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-md  underline ">B-1 License</h2>
              <p className="text-base text-justify">
                <strong>B-1.1</strong> General License. Subject to the terms and
                conditions of this Agreement, See Sight Tours hereby grants to
                you a royalty-free, world-wide, limited, revocable,
                non-transferable, non-sublicensable, non assignable,
                non-exclusive license during the term of these See Sight Tours
                Affiliate Program Service Terms to use, reproduce, incorporate,
                integrate and display the Travel Product Information and Travel
                Product Links on the Partner Site for the sole purpose of
                promoting the Travel Products to End Users, linking such End
                Users from the Partner Site to the See Sight Tours Marketplace.
              </p>
              <p className="text-base text-justify">
                <strong>B-1.2</strong> API License. See Sight Tours may (but
                shall be under no obligation to) provide you with API
                Credentials to access one or more See Sight Tours APIs for the
                purpose of participating in the See Sight Tours Affiliate
                Program. If See Sight Tours agrees to provide you with a See
                Sight Tours API, such provision shall be subject to a
                royalty-free, worldwide, limited, revocable, non-transferable,
                non-sublicensable, non-assignable, non-exclusive license to use
                such See Sight Tours API during the term of these See Sight
                Tours Affiliate Program Service Terms to access and use the
                Travel Product Information solely as set forth in Section B-1.1.
              </p>
              <p className="text-base text-justify">
                <strong>B-1.3 </strong>Additional API License Conditions. If you
                are granted access to one or more See Sight Tours APIs, you
                must:
                <ol className="ml-5">
                  <li>
                    (a) keep the API Credentials secure and you may not share
                    the API Credentials with any third party;
                  </li>
                  <li>
                    (b) use the See Sight Tours API solely to participate in the
                    See Sight Tours Affiliate Program as described in these
                    Service Terms, and strictly in accordance with the API
                    Documentation;
                  </li>
                  <li>
                    (c) comply with any and all limits on your use of the See
                    Sight Tours API that See Sight Tours may set from time to
                    time;
                  </li>
                  <li>
                    (d) not do any of the following:
                    <ol className="ml-5">
                      <li>
                        (i) distribute, sell, lend, transfer, assign or
                        sublicense the licensed rights;
                      </li>
                      <li>
                        (ii) use the See Sight Tours API in order to monitor the
                        availability, performance or functionality of the See
                        Sight Tours API or the Service;
                      </li>
                      <li>
                        (iii) engage in any activity that interferes with,
                        disrupts, harms, or accesses in an unauthorized manner
                        the servers, security, networks, data, applications or
                        other properties or services of See Sight Tours or any
                        third party; or
                      </li>
                      <li>
                        (iv) modify, reverse engineer, copy, or create
                        derivative works of the See Sight Tours API or the
                        Service, or any aspect thereof.
                      </li>
                    </ol>
                  </li>
                </ol>
              </p>
              <p className="text-base text-justify">
                <strong>
                  B-1.4 Affiliate Microsite. From time to time, See Sight Tours
                  may provide you with a QR code (or similar technology) and/or
                  unique URL (together, the “Affiliate Microsite Links”)
                  directing to an Affiliate Microsite. In such circumstances,
                  you may only share the Affiliate Microsite Links with your
                  customers who you have reason to believe may be interested in
                  the Travel Products available to book on the Affiliate
                  Microsite.
                </strong>
              </p>

              <p className="text-base text-justify">
                <strong>B-1.5 </strong>Partner Site. You may not cause or permit
                the display or use of any Travel Product Information or Travel
                Product Links through any website, channel, platform or system
                other than the Partner Site. You shall ensure that the Partner
                Site is not used to send, receive, upload, download, use or
                reuse any Undesirable Material.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">
                B-2 Affiliated Transactions
              </h2>
              <p className="text-base text-justify">
                <strong>B-2.1 </strong>Affiliated Transactions. Upon completion
                of an Affiliated Transaction, See Sight Tours will provide the
                applicable Customer with an electronic acknowledgment and Ticket
                for such Affiliated Transaction. See Sight Tours will be the
                merchant-of-record in all Affiliated Transactions.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">B-3 Commissions; Payment</h2>
              <p className="text-base text-justify">
                <strong>B-3.1 </strong>Subject to{' '}
                <p className="ml-5">
                  (a) any credit, cancellation or refund of an Affiliated
                  Transaction, and
                </p>{' '}
                <p className="ml-5">
                  (b) Section B-4 of these Service Terms, See Sight Tours will
                  pay you a Commission for each Affiliated Transaction.
                </p>
              </p>
              <p className="text-base text-justify">
                <strong>B-3.2 </strong>The Commission Rate shall be based on a
                percentage of the Retail Rate received by See Sight Tours in
                respect of each Travel Product booked by a Customer (net of all
                cancellations, and partial or full refunds). The Commission Rate
                shall be as specified within your See Sight Tours Partner
                Program Account.
              </p>
              <p className="text-base text-justify">
                <strong>B-3.3 </strong>Commissions shall be paid via Electronic
                Funds Transfer or any other method approved by See Sight Tours
                in the month following the calendar month in which each Travel
                Product purchased in an Affiliated Transaction is availed. In
                the event the total amount of Commissions due in any month is
                less than the Minimum Payment Threshold then payment will be
                withheld until the earlier of{' '}
                <p className="ml-5">
                  (a) such time as the total Commissions due (including the
                  previously withheld amount) in a subsequent calendar month are
                  equal to or greater than the Minimum Payment Threshold, or{' '}
                </p>
                <p className="ml-5">(b) the termination of this Agreement.</p>
              </p>
              <p className="text-base text-justify">
                <strong>B-3.4 </strong>You acknowledge and agree that it is your
                responsibility to provide See Sight Tours with accurate and
                complete payment information, and that See Sight Tours has no
                obligation to pay you any Commissions unless or until you have
                provided such information.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">B-4 Effect of Termination</h2>
              <p className="text-base text-justify">
                <strong>B-4.1 </strong>Upon termination of these Service Terms
                or this Agreement for any reason, all licenses and rights
                granted to you pursuant to the Agreement will immediately
                terminate, and you shall cease using the Travel Product Links,
                Travel Product Information, the See Sight Tours APIs, Affiliate
                Microsite Links and the Affiliate Microsite. You shall not be
                entitled to receive any Commissions in respect of Affiliated
                Transactions that occur after the termination date.
                Notwithstanding the foregoing, if See Sight Tours terminates
                these Service Terms or this Agreement due to your breach (or
                where See Sight Tours has reason to believe there has been such
                a breach), you shall not be entitled to receive any Commissions
                that may otherwise have been payable after the termination date,
                including for Affiliated Transactions made prior to the date of
                termination.
              </p>
            </div>
            <div>
              <h2 className="text-md  underline ">
                B-5 See Sight Tours Affiliate Service Definitions
              </h2>
              <p className="text-base text-justify">
                <strong>B-5.1 </strong>“Affiliated Transaction” means a
                Reservation by a Customer on behalf of one or more travelers in
                a single travel itinerary, that takes place on the See Sight
                Tours Marketplace after originating from a click on a Travel
                Product Link on the Partner Site or the Affiliate Microsite
                (such click need not be on the See Sight Tours Product that is
                subsequently booked on the See Sight Tours Marketplace) within
                the validity period of thirty (30) days of a cookie being placed
                on the Customer’s device after visiting the Partner Site or
                Affiliate Microsite.
              </p>
              <p className="text-base text-justify">
                <strong>B-5.2 </strong>“API Credentials” means the credentials
                that allow you to make authenticated requests to a See Sight
                Tours API.
              </p>
              <p className="text-base text-justify">
                <strong>B-5.3 </strong>“API Documentation” means the technical
                documentation made available to you by See Sight Tours setting
                out the terms on which the See Sight Tours API must be used
                (which may be updated by See Sight Tours from time to time).
              </p>
              <p className="text-base text-justify">
                <strong>B-5.4 </strong>“Travel Product Links” means HTML links
                that are made available to you by See Sight Tours that are
                intended to link End Users from the Partner Site to the See
                Sight Tours Marketplace.
              </p>
              <p className="text-base text-justify">
                <strong>B-5.5 </strong>“See Sight Tours API” means an
                application programming interface proprietary to See Sight
                Tours.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndCondition;
